import type { Context, FC, PropsWithChildren } from 'react';
import React, { createContext, useMemo } from 'react';

import type { MainAreaRowContextValue } from './MainAreaRowContextProvider.types';

export const MainAreaRowContext: Context<MainAreaRowContextValue | undefined> = createContext<
  MainAreaRowContextValue | undefined
>(undefined);

type MainAreaRowContextProviderProps = MainAreaRowContextValue;

export const MainAreaRowContextProvider: FC<PropsWithChildren<MainAreaRowContextProviderProps>> = ({
  height,
  children,
}) => {
  const value: MainAreaRowContextValue = useMemo(
    () => ({
      height,
    }),
    [height]
  );

  return <MainAreaRowContext.Provider value={value}>{children}</MainAreaRowContext.Provider>;
};
